import { z } from 'zod';

export const formSchema = z.object({
  equipmentCode: z.string().optional(),
  containerCode: z.string().optional(),
  companyId: z.array(z.string()).optional(),
});

export type FormSchema = z.infer<typeof formSchema>;